'use client'

import React from 'react'
import { Newspaper } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { useChangelogStore } from '@/stores/changelogStore'
import { pushModal } from '@/components/modals'
import { cn } from '@/lib/utils'

interface ChangelogInboxProps {
  variant?: 'light' | 'dark'
}

const ChangelogInbox = ({ variant = 'dark' }: ChangelogInboxProps) => {
  const hasUnread = useChangelogStore((state) => state.hasUnread)

  function handleClick() {
    pushModal('ChangelogModal', { name: 'ChangelogModal' })
  }

  return (
    <Button
      variant="transparent"
      size="icon"
      className={cn(
        'relative h-8 w-8 md:h-10 md:w-10',
        variant === 'light'
          ? 'text-black hover:text-black/80 hover:bg-black/5'
          : 'text-white hover:text-white/80',
      )}
      onClick={handleClick}
    >
      <Newspaper className="h-5 w-5" />
      {hasUnread && (
        <span className="absolute top-1.5 right-1.5 w-2.5 h-2.5 bg-red-500 rounded-full border-2 border-dark-bg" />
      )}
    </Button>
  )
}

export default ChangelogInbox
